import { gql } from '__generated__';

export default gql(`
  query GetParticipantOrders($project_id: ID!, $participant_id: ID!) {
    project(id: $project_id) {
      id
      participant(id: $participant_id) {
        id
        active
        orders {
          id
          invoice_date
          invoice_id
          amount
          balance
          remaining_amount
          refunded_amount
          cancelled
          waitlist
          deletable
          tickets_count
          event {
            id
            title
          }
        }
      }
    }
  }
`);
